<template>
    <autocomplete-multi-selector
        v-model="selectedItems"
        placeholder="Buscar Tags"
        value-key="name"
        :suggestions="suggestions"/>
</template>

<script>
    import AutocompleteMultiSelector from "../AutocompleteMultiSelector/index";
    import {mapGetters} from 'vuex';
    export default {
        name: "TagAutoMultiSelector",
        components: {AutocompleteMultiSelector},
        props: {
            value: Array,
        },
        computed: {
            ...mapGetters([
                'tags'
            ]),
            selectedItems: {
                get: function() {
                    return this.value;
                },
                set: function(value) {
                    this.$emit('input', value)
                }
            }
        },
        mounted() {
            this.$store.dispatch('loadTags');
        },
        methods: {
            suggestions(query, cb) {
                if (query == null) cb([]);
                let results = query
                    ? this.tags.filter((tag) => tag.name.toLowerCase().indexOf(query.toLowerCase()) !== -1)
                    : [];
                cb(results);
            },
        }
    }
</script>